import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgClockSimple = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	fill: "none",
	viewBox: "0 0 16 16",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fill: "currentColor",
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M8 0C3.58172 0 0 3.58172 0 8C0 12.4183 3.58172 16 8 16C12.4183 16 16 12.4183 16 8C16 3.58172 12.4183 0 8 0ZM7 8.41421V3H9V7.58579L12 10.5858L10.5858 12L7 8.41421Z"
	})
});
export default SvgClockSimple;
